module.exports = __webpack_public_path__ + "media/images/icons/social/facebook-684a44378c34ba23a477d200a5ac69584adff0807d19a3259b1c4ae4bdf1db8d.svg";